import api from './api';

export interface ServiceTimeSlot {
  startTime: string;
  endTime: string;
}

export interface ServiceTimeConfig {
  id: string;
  bookingDays: number;
  timeSlots: ServiceTimeSlot[];
  createdAt?: string;
  updatedAt?: string;
}

export interface UpdateServiceTimeConfigRequest {
  bookingDays: number;
  timeSlots: ServiceTimeSlot[];
}

export const getServiceTimeConfig = () => api.get<ServiceTimeConfig>('/service-time-config');

export const updateServiceTimeConfig = (data: UpdateServiceTimeConfigRequest) =>
  api.put<ServiceTimeConfig>('/service-time-config', data);
